export function createRemoveFocus(
  _document = document,
) {
  return function removeFocus() {
    _document.activeElement.blur();
  };
}

export default createRemoveFocus();
